// extracted by mini-css-extract-plugin
module.exports = {"slide-in-fwd-center":"Card_slide-in-fwd-center__2d-Yf"};